<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper4.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="2" :rightBars="rightBars"></menutree>
    <div class="reprot_box">
      <div style="width: 1200px;">
        <div class="title">
          {{reportInfo.title}}
        </div>
        <div class="marks">
          <div>
            来源：{{reportInfo.resource}}
          </div>
          <div>
            发布时间：{{reportInfo.publishTime}}
          </div>
          <div>
            浏览次数：{{reportInfo.scanTime}}
          </div>
        </div>
        <div class="table" v-html="reportInfo.content">


        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  name:'reportInfo',
  components:{top,menutree,bottom},
  data () {
    return {
      reportInfo:{},
      id:'',
      menuchild:[{
        lable:'职业卫生报告',
        value:'1',
        path:'/reports'
      },{
        lable:'新闻资讯',
        value:'2',
        path:'/newsList'
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'信息公开',
        path:'',
      },{
        lable:'新闻资讯',
        path:'',
      }]
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getData()
  },
  methods:{
    getData(){
      const url=`https://api.hzshjc.com/index/newsInfo/${this.id}`;
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background:'rgba(0, 0, 0, 0)'
      });
      this.$axios({
        method:'get',
        url:url
      }).then(res=>{
        if(res.data.code=='200'){
          this.reportInfo = res.data.data;
        }
        loading.close()
      })
    }
  }
}
</script>

<style scope lang="less">
  .ql-align-center{
    text-align: center !important;
  }
  strong{
    font-weight: bold !important;
  }
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .reprot_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .title{
      height: 50px;
      font-size: 16px;
      color: #666;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .marks{
      font-size: 12px;
      color: #999;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .table{
      clear: both;
      border: 1px solid #f0f0f0;
      margin:10px 0;
      padding: 20px;
      line-height: 30px;
      color: #666;
      font-size: 14px;
      min-height: 600px;
      img{
        max-width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/reports/newsInfo.vue